import { render, staticRenderFns } from "./SelectPreferenceTags.vue?vue&type=template&id=23150b6e&scoped=true&"
import script from "./SelectPreferenceTags.vue?vue&type=script&lang=js&"
export * from "./SelectPreferenceTags.vue?vue&type=script&lang=js&"
import style0 from "./SelectPreferenceTags.vue?vue&type=style&index=0&id=23150b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23150b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VCheckbox,VProgressCircular})
